import { Rect, Group } from 'react-konva';
import { PLATFORM_THEME_COLORS } from '@thinknet-gmbh/platform-common-ui';

import {
  HEADER_ROW_HEIGHT,
  DATE_COLUMN_WIDTH,
} from 'src/pages/gantt/gantt-calendar/gantt-view/gantt-view.constants';
import { IViewDate } from 'src/pages/gantt/gantt-calendar/gantt-view/gantt-view.interfaces';
import {
  GanttColumnTypesEnum,
  GANTT_DISABLED_DAY_COLUMN_FOR_TYPES,
} from 'src/pages/gantt/gantt.constants';

import {
  COLUMN_WIDTH,
  COLUMN_HEIGHT,
} from 'src/pages/gantt/gantt-calendar/gantt-view/gantt-view.constants';

import { checkIfHaveWorkingHours, getRowStatusColor } from './status-columns-layer.helpers';
import { IStatusColumnsLayer } from './status-columns-layer.interfaces';
import { CurrentNotActiveDayColumn } from './current-not-active-day-column';

const {
  grayVariations: { athensGray },
} = PLATFORM_THEME_COLORS;
const StatusColumnsLayer = ({
  colorSchema,
  dateValues,
  ganttData,
  fullWidth,
}: IStatusColumnsLayer) => (
  <Group listening={false}>
    {/* Day is holiday or weekend */}
    {dateValues.map(({ types }: IViewDate, index) => {
      const endTopColumnPosition = index * COLUMN_HEIGHT + HEADER_ROW_HEIGHT;
      const isCurrentDay = types.includes(GanttColumnTypesEnum.CURRENT_DAY);
      const isNotActiveDay = types.some(type => GANTT_DISABLED_DAY_COLUMN_FOR_TYPES.includes(type));

      if (isCurrentDay || isNotActiveDay) {
        const color = getRowStatusColor(types, colorSchema);

        return (
          <Group key={index} listening={false}>
            <Rect
              x={0}
              perfectDrawEnabled={false}
              y={endTopColumnPosition}
              width={fullWidth}
              height={COLUMN_HEIGHT}
              fill={color}
            />
          </Group>
        );
      }

      return null;
    })}

    {/* Employee day is holiday or weekend */}
    {ganttData.map(({ employee }: any, employeeIndex: number) => (
      <Group key={employeeIndex} listening={false}>
        {dateValues.map(({ weekDay, date, types }: IViewDate, index) => {
          const startXPoint = employeeIndex * COLUMN_WIDTH + DATE_COLUMN_WIDTH;
          const startYPoint = COLUMN_HEIGHT * index + HEADER_ROW_HEIGHT;
          const endXPoint = startXPoint + COLUMN_WIDTH;
          const endYPoint = startYPoint + COLUMN_HEIGHT;
          const hasWorkingHours = checkIfHaveWorkingHours(employee.workingHours, date, weekDay);
          const isCurrentDay = types.includes(GanttColumnTypesEnum.CURRENT_DAY);
          const isHoliday = types.includes(GanttColumnTypesEnum.HOLYDAY);

          if (!isCurrentDay && !hasWorkingHours && !isHoliday) {
            return (
              <Rect
                key={index}
                x={startXPoint}
                y={startYPoint}
                width={COLUMN_WIDTH}
                height={COLUMN_HEIGHT}
                perfectDrawEnabled={false}
                fill={colorSchema?.weekendColor || athensGray}
              />
            );
          }

          const isNotActiveDay = types.some(type =>
            GANTT_DISABLED_DAY_COLUMN_FOR_TYPES.includes(type)
          );

          if (isCurrentDay && (!hasWorkingHours || isNotActiveDay)) {
            return (
              <CurrentNotActiveDayColumn
                key={index}
                colorSchema={colorSchema}
                isHoliday={types.includes(GanttColumnTypesEnum.HOLYDAY)}
                elementPoints={[startXPoint, startYPoint, endXPoint, endYPoint]}
              />
            );
          }

          return null;
        })}
      </Group>
    ))}
  </Group>
);

export default StatusColumnsLayer;
